import React, {useState, useEffect} from 'react';
import './Thankyou.css';
import { Link } from 'react-router-dom';
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./firebaseAuth";

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
function Thankyou() {

  const [user, setUser] = useState(null);
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // yes you are logged in
        setUser(user);
      } else {
        // user is logged out
        console.log("you are logged out");
        setUser(null);
      }
    });
  }, []);
  if (user === null) {
  return (
    <div className='order__confirm'>
        <h1>Hello Mudit Ojha</h1>
        <h2>Thank you for your order</h2>
        <h3>Your Order Number is : 101010</h3>
        <h4>Order Total :$2400</h4>
        <Link to="/">
        <button>Continue Shpping</button>
        </Link>
    </div>
  )
}
return (
  <div className='order__confirm'>
      <h1>Hello {user.email}</h1>
      <h2>Thank you for your order</h2>
      <h3>Your Order Number is : 101010</h3>
      <h4>Order Total :$2400</h4>
      <Link to="/">
      <button>Continue Shpping</button>
      </Link>
  </div>
)
}

export default Thankyou